import React from 'react';
import { FilterProps } from '@saucelabs/ds-filters';
import { IconDeviceVmOutline } from '@saucelabs/ds-icons';

import { FilterKey } from './types';

export const MAP_FILTER_KEY_TO_PROPS: Record<FilterKey, Partial<FilterProps>> = {
  build: {
    label: 'Build',
    selectionMode: 'multiple',
    hasSearch: true,
  },
  os: {
    label: 'OS',
    selectionMode: 'multiple',
    hasSearch: true,
  },
  browser: {
    label: 'Browser',
    selectionMode: 'multiple',
    hasSearch: true,
  },
  device: {
    label: 'Device',
    selectionMode: 'multiple',
    hasSearch: true,
  },
  tag: {
    label: 'Tag',
    selectionMode: 'multiple',
    hasSearch: true,
  },
  framework: {
    label: 'Framework',
    selectionMode: 'multiple',
    prefixIcon: IconDeviceVmOutline,
  },
  deviceGroup: {
    label: 'Device Group',
    selectionMode: 'single',
  },
};

export const COMMON_VDC_FILTERS: FilterKey[] = [
  'build',
  'os',
  'browser',
  'framework',
  'tag',
];
export const COMMON_RDC_FILTERS: FilterKey[] = [
  'build',
  'os',
  'device',
  'tag',
];
